import React, { useState, useEffect } from 'react';
import { getMemberTransactions, membersessions, getPlans } from '../../services/memberApiServices';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import moment from "moment";
import defaultImg from "../../components/images/defaultPerson.png";
import { MDBBadge, MDBBtn, MDBCardBody, MDBCardImage, MDBTypography } from 'mdb-react-ui-kit';
import { useCart } from './CartContext';
import { formatDate } from '../../utils/DateFormat';
import { BasePlanName } from '../../utils/BasePlanName';

function ViewProfile() {
    const navigate = useNavigate();
    const { getMemberId, handleReload, getMemberUrl } = useCart();
    const [memberData, setMemberData] = useState({});
    const [loading, setLoading] = useState(true);
    const [editMember, setEditMember] = useState(false)
    const toggleEdit = () => { setEditMember(!editMember) }
    const [sessionData, setSessionData] = useState([])
    const [refresh, setRefresh] = useState(false)

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const userGymURL = params.get('id') ? params.get('id') : "";
    let userEventGymURL = params.get('sid') ? params.get('sid') : "";
    const hostname = window.location.hostname;
    let subdomain = "";


    const [plans, setPlans] = useState("");

    useEffect(() => {
        async function fetchPlans() {
            try {
                const loggedUser = JSON.parse(localStorage.getItem("memberinfo"));
                const planResponse = await getPlans(loggedUser.gymid);

                if (!planResponse || planResponse === "false") {
                    //   setApiError(true);
                } else {
                    const plans = await planResponse.json();
                    if (plans) {
                        setPlans(plans);
                    }
                }
            } catch (error) {
                console.error("Error fetching plans:", error);
                // setApiError(true);
            }
        }

        fetchPlans();
    }, [getMemberId, refresh]);


    useEffect(() => {
        const fetchMemberData = async () => {
            try {
                if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
                    return
                }
                setLoading(true);
                const response = await getMemberTransactions(getMemberId());
                if (response && response !== "false") {
                    const data = await response.json();
                    if (data && data.length > 0) {
                        setMemberData(data[0]);
                    }
                }
            } catch (error) {
                console.error("Error fetching member data:", error);
            } finally {
                setLoading(false);
                setRefresh(false)
            }
        };
        fetchMemberSession()
        fetchMemberData();

    }, [getMemberId, refresh]);
    const fetchMemberSession = async () => {
        if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
            return
        }
        const resp = await membersessions(getMemberId());

        if (!resp) {

            return;
        }
        if (resp === "false") {
            // setApiError(true)
            return;
        }
        const sessionData = await resp.json();
        console.log(sessionData);
        setSessionData(sessionData)
    }

    console.log(memberData, 'memberData');


    // Format member data
    const formattedData = {
        name: memberData?.fname ? `${memberData.fname} ${memberData.lname}` : "--",
        email: memberData.email,
        mid: memberData.mid,
        phone: memberData.number,
        memberId: memberData.mid,
        image: memberData.imgurl,
        address: memberData.address ? memberData.address : '--',
        age: memberData.age,
        gender: memberData.sex,
        bloodGroup: memberData.bloodgroup,
        height: memberData.height ? `${memberData.height} cm` : "--",
        weight: memberData.weight ? `${memberData.weight} kg` : "--",
        checkInStatus: memberData.checkinflag ? "Auto check-in" : "Manual check-in",
        lastCheckIn: memberData.checkindate ? new Date(memberData.checkindate).toLocaleDateString() : "Never"
    };


    const addandSave = null

    let membership = {};
    let PauseObj = {};
    let session = sessionData.length > 0 && sessionData.filter(item => memberData?.trans?.length > 0 ? item.transid === memberData?.trans[0]?._id : false)
    if (memberData && memberData?.trans?.length > 0) {
        const { plan, addons, subplan } = memberData;

        let membertrans = memberData.trans.filter((obj) => obj.isplan == "1" && (new Date() < new Date(obj.expirydate))).sort((a, b) => b.expirydate - a.expirydate);
        let membertran = memberData.trans.sort((a, b) => b.expirydate - a.expirydate);

        if (plan && plan.length > 0 && membertrans.length > 0) {
            membership = plan.find(item => item._id === membertrans[0].itemid) || {};
            if (membership._id) {
                membership.membershiptype = "plan";
                membership.displayName = membership.name;  // base plan name
            }
            session = sessionData.length > 0 && sessionData.filter(item => item.transid === membertrans[0]?._id)
        }

        if (plan && plan.length > 0 && !membership._id) {
            membership = plan.find(item => item._id === membertran[0].itemid) || {};
            if (membership._id) {
                membership.membershiptype = "plan";
                membership.displayName = membership.name;
            }
            session = sessionData.length > 0 && sessionData.filter(item => item.transid === membertrans[0]?._id)
        }

        if (addons && addons.length > 0 && !membership._id) {
            membership = addons.find(item => item._id === membertran[0].itemid) || {};
            if (membership._id) {
                membership.membershiptype = "addon";
                membership.displayName = membership.name;  // addon name
            }
        }

        if (subplan && subplan.length > 0 && !membership._id) {
            membership = subplan.find((item) => item._id === membertran[0].itemid) || {};
            if (membership._id) {
                membership.membershiptype = "plan";
                membership.displayName = `${BasePlanName(plans, membership.baseplan)} - ${membership.name}`;
            }
        }


    }

    const remainingSessions = session && session.length > 0 ? session[0].balsessions : null

    console.log("membership", membership)

    const handleLogin = () => {
        navigate('/memberlogin', { state: { path: userEventGymURL != "" ? `/availablesessions?sid=${userEventGymURL}` : "/availablesessions" } })
    }
    return (
        <div>
            <div className="dashboard-announcements-sidbar-list">
                {/* <MDBCard className="mb-4"> */}
                {localStorage.getItem("loggedMemberInfo") && localStorage.getItem("memberinfo") ? <MDBCardBody className="text-center">
                    <MDBCardImage
                        src={getMemberUrl() ? getMemberUrl() : defaultImg}
                        alt="avatar"
                        className="rounded-circle mx-auto d-block"
                        style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                        onError={(e) => {
                            e.target.src = 'https://via.placeholder.com/150';
                        }}
                    />
                    <div className="my-3">
                        <MDBTypography tag="h4">{formattedData?.name}</MDBTypography>
                        <p className="text-muted mb-1">Member ID: {formattedData?.mid}</p>
                        <p className="text-muted mb-1">Mobile: {formattedData?.phone || "--"}</p>
                        <p className="text-muted mb-1" >
                            Email:
                            <span className='btn-link ms-1' style={{ textDecoration: `${formattedData?.email ? "underline" : "none"}` }} >
                                {formattedData?.email || "--"}
                            </span>
                        </p>
                    </div>
                    <div className='p-3 square border rounded'>
                        <div className="d-flex justify-content-between align-items-center mb-2">

                            <span className="text-muted">Membership </span>
                            <MDBTypography className="mb-0 text-dark">
                                {membership?.displayName?.trim() || membership?.name?.trim() || "No Plan Associated"}
                            </MDBTypography>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-muted">Status</span>
                            <MDBBadge color="success" pill>{!memberData.issuspend ? memberData.membershipstatus ? memberData.membershipstatus : ((new Date(memberData.expirydate) < new Date()) ? "Inactive" : "Active") : "suspend"}</MDBBadge>
                        </div>
                        <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Expires</span>
                            <span className='text-dark'>{memberData.expirydate ? formatDate(memberData.expirydate) : "--"}</span>
                        </div>
                        {remainingSessions !== null && <div className="d-flex justify-content-between mb-2">
                            <span className="text-muted">Sessions</span>
                            <span className='text-dark'>{remainingSessions}</span>
                        </div>}

                        <div className="d-flex justify-content-between">
                            <span className="text-muted">Last check-in</span>
                            <span className='text-dark'>{memberData?.attendance && memberData?.attendance.length > 0 ? formatDate(memberData?.attendance[0]?.intime) : "--"}</span>
                        </div>
                        <div className="mt-3">
                            <MDBBtn color="primary" size="sm" block onClick={() => navigate('/membershipplans')}>
                                Upgrade Plan
                            </MDBBtn>
                        </div>
                    </div>
                </MDBCardBody> :
                    (
                        <div className="login-content">
                            <p>To view your Details, please log in.</p>
                            <MDBBtn className="btn-primary" onClick={handleLogin}>Log in</MDBBtn>
                        </div>
                    )}
                {/* </MDBCard> */}
            </div>
        </div>
    )
}

export default ViewProfile
